import { GlButton } from '@gitlab/ui';
import { ROUTES } from '../../../constants';
export default {
    name: 'DesignPreviewCloseButton',
    components: {
        GlButton
    },
    ROUTES
};
